export default {
    meta: {
        title: '新增跟进',
        url: '/standardstore/franchiseelist',
        urlName: '标准版拓店-加盟商',
    }
};
